module.exports = __webpack_public_path__ + "img/email-header-introspection.31334676.png";